import { useEffect, useState } from 'react';

import { CollectionConfig, CollectionItem, CollectionServices } from 'types';

const useCollectionServices = <Config extends CollectionConfig, Item extends CollectionItem>(
  collectionServices: CollectionServices<Config, Item>,
) => {
  const [items, setItems] = useState(collectionServices.getItems);

  useEffect(() => {
    const unsubscribe = collectionServices.onItemChange(() => {
      setItems(collectionServices.getItems());
    });

    return unsubscribe;
  }, [collectionServices]);

  return items;
};

export default useCollectionServices;
